import * as LoginActions from '../actions/login';

export interface State {
	loggedIn: boolean;
	user: {
		active: boolean;
		email: string;
		first_name: string;
		last_name: string;
		id: number;
		name: string;
		rule: any;
	};
}

interface User {
	active: boolean;
	email: string;
	first_name: string;
	last_name: string;
	id: number;
	name: string;
	rule: any;
}

export const initialState: State = {
	loggedIn: false,
	user: {
		active: false,
		email: '',
		first_name: '',
		last_name: '',
		id: -1,
		name: '',
		rule: null
	}
};

export function reducer(state: State = initialState, action: LoginActions.All): State {
	switch (action.type) {
		case LoginActions.LOGIN_SUCCESSFUL:
			return {...state, ...{ loggedIn: true, user: action.payload.user }};

		case LoginActions.LOGIN_FAILED:
			return {...state, ...initialState};

		default:
			return state;
	}
}

export const GetUserId = (s: State): number => s.user && s.user.id || 0;
export const GetUser = (s: State): User => s.user;
export const IsUserLoggedIn = (s: State): boolean => s.loggedIn;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/reducers/login.ts